import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { I18nService } from "src/app/service/i18n.service";
import { UtilService } from "src/app/service/util.service";
import * as CONSTANTS from '../../constants'
import { environment } from "src/environments/environment";
import { currentBalanceValidator } from "../validators/mortgage_details.validator";

@Component({
    selector: 'mortgage-detail',
    templateUrl: './mortgage_details.component.html',
    styleUrls: ['./mortgage_details.component.less']
})
export class MortgageDetailComponent implements OnInit {
    currentLang: string;
    listOfMortgage: Array<object> = new Array<object>();
    mortDetailFrmGrp: FormGroup;
    prequalObj: any;
    mortgageBalance: string;
    mortgageProvider = []
    newProviderFlag: boolean[];
    selectedValue: boolean[];
    manualProvider = "";
    checked = [];
    selectedMortgageProvider = [];
    displayValidation: boolean = true;
    manualCheck = false;
    estimatedAmount = '';
    manualProviderName = '';
    isSubmitted: boolean = false;
    mortgageSum: number = 0;
    liabilities = [];
    popOverType: String;
    isValue: boolean = false;
    error: any[];
    currLangEn = 'en';
    currLangFr = 'fr';
    prequalType = 'P';
    switchType = 'S';
    notListedEn = "Not Listed";
    notListedFr = "Ne figure pas dans la liste";
    type = "string";
    isAllChecked: boolean = false;
    balanceError: boolean = false;



    constructor(private util: UtilService,
        private i18nService: I18nService, private router: Router, private _activatedRoute: ActivatedRoute,
    ) {
        this.util.sidebarTitle.next('slideTitles.mortgageDetails');
    }
    ngOnInit(): void {
        this.prequalObj = this.util.getSessionStorage();
        this.currentLang = this.i18nService.getCurrentLang();
        this.createListOfMortgage();
        this.createFrmGrp();
        this.createProvider();
        this.valueChanges();
    }

    valueChanges() {
        this.mortDetailFrmGrp.get('mrtgManualProvider')?.valueChanges.subscribe(res => {
            this.manualProvider = res;
        })
        this.listOfMortgage.forEach((_, i) => {
            this.mortDetailFrmGrp.get('checked' + i).valueChanges.subscribe(res => {
                this.checked[i] = res;
                if (this.checked[i] == true) this.displayValidation = true;
            })
            this.mortDetailFrmGrp.get('mortgageProviderControl' + i).valueChanges.subscribe(res => {
                this.selectedMortgageProvider[i] = res;
            })
        })
        this.mortDetailFrmGrp.get('checkedManual')?.valueChanges.subscribe(res => {
            this.manualCheck = res;
            if (this.manualCheck == true) this.displayValidation = true;
        })
        this.mortDetailFrmGrp.get('estimatedAmount')?.valueChanges.subscribe(res => {
            this.estimatedAmount = res;
            if (this.listOfMortgage.length > 0) {
                if (this.estimatedAmount.replace(/[^0-9.]/g, '') !== '' && Number(this.estimatedAmount.replace(/[^0-9.]/g, '')) > 0) {
                    this.isValue = true;
                    this.displayValidation = true;
                    this.mortDetailFrmGrp.get('checkedManual')?.setValue(true);
                    this.manualCheck = true;
                }
                else {
                    this.isValue = false;
                    this.mortDetailFrmGrp.get('checkedManual')?.setValue(false);
                    this.manualCheck = false;
                }
            }
        })
        this.mortDetailFrmGrp.get('manualProviderName')?.valueChanges.subscribe(res => {
            this.manualProviderName = res;
            const manualProviderControl = this.mortDetailFrmGrp.get('manualProviderName');
            if (manualProviderControl) {
                manualProviderControl.markAsTouched({ onlySelf: true });
                manualProviderControl.markAsDirty({ onlySelf: true });
                manualProviderControl.updateValueAndValidity({ onlySelf: true, emitEvent: false });
            }
        })
    }

    createProvider() {
        this.mortgageProvider = [
            { "en": 'National Bank', "fr": "Banque Nationale" },
            { "en": 'RBC', "fr": "RBC" },
            { "en": "B2B Bank", "fr": "B2B Banque" },
            { "en": "Equitable Bank", "fr": "Banque Équitable" },
            { "en": "Home Trust Company", "fr": "Compagnie Home Trust" },
            { "en": "Manulife", "fr": "Manuvie" },
            { "en": "Nesto", "fr": "Nesto" },
            { "en": "Tangerine", "fr": "Tangerine" },
            { "en": "True North", "fr": "True North" },
            { "en": "Desjardins", "fr": "Desjardins" },
            { "en": "ATB", "fr": "ATB" },
            { "en": "MCAP", "fr": "MCAP" },
            { "en": "Van City", "fr": "Van City" },
            { "en": "Sun Life", "fr": "Sun Life" },
            { "en": " BMO", "fr": "BMO" },
            { "en": "Bank of Nova Scotia", "fr": " Banque de Nouvelle-Écosse" },
            { "en": "TD", "fr": "TD" },
            { "en": "First National Financial", "fr": "Financière First National" },
            { "en": "Not Listed", "fr": "Ne figure pas dans la liste" }]

    }
    setPopOver(type: String) {
        this.popOverType = type;
    }
    createListOfMortgage() {
        this.listOfMortgage = new Array<Object>();
        if (!this.prequalObj.switched_liabilities) {
            this.prequalObj.switched_liabilities = [];
        }
        this.prequalObj?.switched_liabilities?.forEach(liabilityEach => {
            const liability = { ...liabilityEach };
            if (!liability.creditLimit && liability.authorizedLimit) {
                liability.creditLimit = liability.authorizedLimit;
            }
            this.listOfMortgage.push(liability);
        })
        this.selectedMortgageProvider = this.listOfMortgage.map(() => '');
        this.newProviderFlag = new Array(this.listOfMortgage.length).fill(false);
        this.selectedValue = new Array(this.listOfMortgage.length).fill(false);
        this.checked = new Array(this.listOfMortgage.length).fill(false);
        if (this.listOfMortgage.length == 0) {
            this.manualCheck = true;
        }
    }
    createFrmGrp() {
        this.mortDetailFrmGrp = new FormGroup({})
        this.listOfMortgage.forEach((_, i) => {
            this.mortDetailFrmGrp.addControl(
                `checked${i}`, new FormControl(false, Validators.requiredTrue)
            )
            this.mortDetailFrmGrp.addControl(
                `mortgageProviderControl${i}`, new FormControl('', Validators.required),
            )
            this.mortDetailFrmGrp.addControl(
                `newProvider${i}`, new FormControl('', [
                    Validators.required,
                    Validators.minLength(1),
                    Validators.pattern('^[a-zA-Z0-9 ]{1}[a-zA-Z0-9 ]+$')
                ])
            )
        })
        this.mortDetailFrmGrp.addControl('checkedManual', new FormControl(false, Validators.requiredTrue)),
            this.mortDetailFrmGrp.addControl('estimatedAmount', new FormControl('', [Validators.required, currentBalanceValidator]),),
            this.mortDetailFrmGrp.addControl('mrtgProvider', new FormControl()),
            this.mortDetailFrmGrp.addControl('mrtgManualProvider', new FormControl('', Validators.required)),
            this.mortDetailFrmGrp.addControl('manualProviderName', new FormControl(
                '', [
                Validators.required,
                Validators.minLength(1),
                Validators.pattern('^[a-zA-Z0-9]{1}[a-zA-Z0-9 ]+$')
            ]
            ))
    }
    selected(index: any) {
        this.selectedValue[index] = true;
    }

    formValid() {
        if (this.listOfMortgage.length > 0) {
            for (let i = 0; i < this.listOfMortgage.length; i++) {
                if (this.checked[i] == true) {
                    if (!this.listOfMortgage[i]?.['companyName']) {
                        if (((this.currentLang === this.currLangEn && this.selectedMortgageProvider[i] != this.notListedEn) || (this.currentLang == this.currLangFr && this.selectedMortgageProvider[i] != this.notListedFr)) && this.selectedMortgageProvider[i] != '') continue;
                        else if (this.selectedMortgageProvider[i] == '') return false;
                        else if ((this.currentLang == this.currLangEn && this.selectedMortgageProvider[i] == this.notListedEn) || (this.currentLang == this.currLangFr && this.selectedMortgageProvider[i] == this.notListedFr)) {
                            if (this.mortDetailFrmGrp.get('newProvider' + i)?.value == '') {
                                return false;
                            }
                        }
                    }
                    else {
                        continue;
                    }
                }
            }
        }
        if (this.manualCheck) {
            const manualProviderControl = this.mortDetailFrmGrp.get('manualProviderName');
            manualProviderControl?.markAsTouched();
            manualProviderControl?.updateValueAndValidity();
            if (this.manualCheck && this.estimatedAmount != '' && this.manualProvider != '') {
                if (((this.currentLang == this.currLangEn && this.manualProvider == this.notListedEn) || (this.currentLang == this.currLangFr && this.manualProvider == this.notListedFr)) && manualProviderControl?.invalid) {
                    this.util.adobeAnalyticalErrorMsg("financial-institution", "missing", "", null);
                    return false;
                }
                else {
                    if ((this.currentLang == this.currLangEn && this.manualProvider == this.notListedEn) || (this.currentLang == this.currLangFr && this.manualProvider == this.notListedFr)) { this.manualProvider = this.manualProviderName; }
                    var balance = Number(this.estimatedAmount.replace(/[^0-9.]/g, ''));
                    balance = this.util.validateCurrency(balance, 7);
                    const obj =
                    {
                        "outstandingBalance": balance,
                        "companyName": this.manualProvider,
                        "liabilityCategory": "CVD",
                        "liabilityNumber": "SL00001",
                        "liabilityType": "302",
                        "statusCode": "O",
                        "cibcInstrumentIndicator": "N",
                    }
                    this.prequalObj.switched_liabilities.push(obj);
                    if (this.prequalObj.users[0]?.liability == null) {
                        this.prequalObj.users[0].liability = [];
                    }
                    this.prequalObj.users[0].liability.push(obj);
                    this.mortgageSum += obj.outstandingBalance;
                    this.prequalObj.mortgage_provider = this.manualProvider;
                    return true;
                }
            }
            else {
                if (this.estimatedAmount == '') {
                    this.util.adobeAnalyticalErrorMsg("current-balance", "missing", "", null);

                }
                if (this.manualProvider == '') {
                    this.util.adobeAnalyticalErrorMsg("financial-institution", "missing", "", null);

                }
                return false;
            }

        }
        if (!this.isChecked()) {
            return false;
        }
        return true;
    }
    isChecked() {
        if (this.listOfMortgage.length > 0) {
            for (let index = 0; index < this.listOfMortgage.length; index++) {
                this.isAllChecked = this.mortDetailFrmGrp?.get('checked' + index)?.valid;
                if (this.isAllChecked) {
                    return true
                }
            }
        }
            if (!this.isAllChecked && !this.manualCheck) {
                this.displayValidation = false;
                this.util.adobeAnalyticalErrorMsg("liability-check", "missing", "", null);
                return false;
            }
        
    }




    onContinue() {
        this.mortgageSum = 0
        this.balanceError = false;
        this.error = [];
        this.isSubmitted = true;
        if (this.formValid()) {
            this.prequalObj?.switched_liabilities?.forEach((liabilityEach, index) => {
                if (!liabilityEach.companyName) {
                    if (this.checked[index] == true) {
                        if (this.selectedMortgageProvider[index] != 'Not Listed') {
                            liabilityEach['companyName'] = this.selectedMortgageProvider[index];
                            this.prequalObj.mortgage_provider = this.selectedMortgageProvider[index];
                            liabilityEach['statusCode'] = CONSTANTS.applicationConstants.selectedLiabilityCode;
                            this.mortgageSum += liabilityEach.outstandingBalance;
                        }
                        else {
                            liabilityEach['companyName'] = this.mortDetailFrmGrp.get('newProvider' + index)?.value;
                            this.prequalObj.mortgage_provider = this.mortDetailFrmGrp.get('newProvider' + index)?.value;
                            liabilityEach['statusCode'] = CONSTANTS.applicationConstants.selectedLiabilityCode;
                            this.mortgageSum += liabilityEach.outstandingBalance;
                        }
                    }
                }
                else {
                    if (this.checked[index] == true) {
                        liabilityEach['statusCode'] = CONSTANTS.applicationConstants.selectedLiabilityCode;
                        this.prequalObj.mortgage_provider = liabilityEach.companyName;
                        this.mortgageSum += liabilityEach.outstandingBalance;
                    }
                }
            })
            this.prequalObj.users.forEach((user) => {
                user.liability.forEach(liabObj => {
                    const selectedLiability = this.prequalObj.switched_liabilities.find(obj => obj.liabilityNumber === liabObj.liabilityNumber);
                    if (selectedLiability?.statusCode) {
                        liabObj.statusCode = selectedLiability.statusCode;
                    }
                })
            })

            this.prequalObj.mortgage_balance = this.mortgageSum;
            this.prequalObj['switchReqAmnt'] = this.prequalObj.mortgage_balance;
            if (this.mortgageSum >= 10000) {
                this.util.setSessionStorage(this.prequalObj);
                let equityChk = this.util.equityCheck();
                if (equityChk) {
                    this.router.navigate(['../request-callback'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
                }
                else {
                    this.router.navigate(['../additonal-mortgage-details'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
                }
            }
            else {
                this.balanceError = true;
                this.util.adobeAnalyticalErrorMsg("mortgage-balance", "below-minimum", "", null);
            }
        }
        else {
            const ctrls = this.mortDetailFrmGrp.controls;
            for (let key in ctrls) {
                if (ctrls[key].status == "INVALID") {
                    const el = document.getElementById(key);
                    if (el) {
                        el.focus();
                    }
                    break;
                }
            }
        }
    }


}